export default __webpack_public_path__ + "static/media/viber.421d0eac.svg";